export function toggleImageVisibility(imgsEl, currentVariantImageEl) {
	imgsEl.forEach(el => {
		el.classList.add("d-none");
	});
	currentVariantImageEl.classList.remove("d-none");
}
